import { render } from "./SkillsList.vue?vue&type=template&id=a0dd3e12&scoped=true&ts=true"
import script from "./SkillsList.vue?vue&type=script&lang=ts"
export * from "./SkillsList.vue?vue&type=script&lang=ts"

import "./SkillsList.vue?vue&type=style&index=0&id=a0dd3e12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0dd3e12"]])

export default __exports__